export enum LocalStorageKeys {
    LANGUAGE = 'language',
    PRIVACY_POLICY = 'privacyPolicy',
    SEARCHES = 'searches',
}
